import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import { Navigate } from '../../node_modules/react-router/dist/index';
import SuccessPage from 'pages/extra-pages/SuccessPage';
import NotFoundPage from 'pages/extra-pages/NotFoundPage';
import JsonDataDisplay from 'components/@extended/JsonTest';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthVerifyRegistration = Loadable(lazy(() => import('pages/authentication/InitializeRegistration')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/Register')));
const AuthResetPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const AuthOtpVerification = Loadable(lazy(() => import('pages/authentication/OTPVerification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      index: true,
      element: <Navigate to="login" />
    },
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'initialize-registration',
      element: <AuthVerifyRegistration />
    },
    {
      path: 'register/:regpass',
      element: <AuthRegister />
    },
    {
      path: 'forgot-password',
      element: <AuthResetPassword />
    },
    {
      path: 'verification',
      element: <AuthOtpVerification />
    },
    { path: 'success', element: <SuccessPage /> },
    {
      path: '404',
      element: <NotFoundPage />
    }
  ]
};

export default LoginRoutes;
